var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundWidgetSuggestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 160,
    viewBox: "0 0 854 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20994_306977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M854 0H0V160H854V0Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M854 0V109.7C737.7 130.8 581.9 119.5 514.5 71C490.5 53.7 482.4 27.5 486.6 0H854Z",
    fill: "black",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.9 160H0V136.8C26.3 106 61.6 86.2 88.4 79.2C110.5 73.4 245.5 49.6 358 103C390.1 118.2 420.2 138.3 441.9 160Z",
    fill: "black",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("path", {
    d: "M816.3 79.5C800.2 115.5 721.2 121.3 693.8 88.8C683.7 76.8 681 54.8 688.2 36.4C695.2 18.5 709.2 3.9 717.7 0H762.6C771.8 2.5 781.4 6.8 790.4 13.9C811.2 30.1 825.7 58.7 816.3 79.5Z",
    fill: "black",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.2 96.4C718.5 95.8 716 92.2 716.6 88.2L721 58.7C721.6 54.7 729.4 50.1 733 50.6L729.9 90.2C729.3 94.2 725.8 97 722.2 96.4Z",
    fill: "#18285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.4 80.8C788 79.5 789.4 76.6 787.2 73.1L770 52.8C767.8 49.3 755.2 49.8 752.2 51.6L775 80.3C777.3 83.9 783 82 785.4 80.8Z",
    fill: "#18285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.4 105.5L770.5 66.2C770.5 50 763.9 50.3 760.7 49.4C754.8 47.8 742.9 47.3 737.8 49C730.5 51.5 726.2 49.6 726.2 67.7L727.2 103.8C750.1 104.4 758.4 105 770.4 105.5Z",
    fill: "#1E2E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.6 48.9C745.7 48.7 753.3 46.8 755.3 49.9C757.9 54.1 747 64 747 64C747 64 731.7 49.6 742.6 48.9Z",
    fill: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.1 17.7999C731.4 25.4999 730.3 29.2999 732.7 40.1999C735.3 52.3999 745.8 46.5999 751 43.6999C754.1 41.8999 756.7 35.4999 755.2 27.1999C754.8 24.7999 758.8 19.1999 757 16.7999C753.7 12.1999 734.2 12.8999 733.1 17.7999Z",
    fill: "#FF7745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.8 29.2C741.5 34.2 740.8 47.6 741.2 50.2C742.2 57.2 753.1 55 753.2 52.2C753.6 45.5 753.9 36.9 753.9 36.9C753.9 36.9 742.6 17 741.8 29.2Z",
    fill: "#FF7745"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M739.9 34.1999C739 34.1999 738.1 33.9 737.6 32.9C736.9 31.2 738.8 27.4999 739 27.0999C739.1 26.8999 739.4 26.7999 739.6 26.8999C739.8 26.9999 739.9 27.2999 739.8 27.4999C739.1 28.8999 738 31.4999 738.4 32.4999C738.9 33.5999 740.6 33.0999 740.6 33.0999C740.9 32.9999 741.1 33.2 741.2 33.4C741.3 33.7 741.1 33.8999 740.9 33.9999C740.7 34.0999 740.3 34.1999 739.9 34.1999Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M746.701 27.5999C746.701 28.2999 746.101 28.8999 745.401 28.8999C744.701 28.8999 744.101 28.2999 744.101 27.5999C744.101 26.8999 744.701 26.2999 745.401 26.2999C746.101 26.2999 746.701 26.8999 746.701 27.5999Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.1 27.6999C737.1 28.3999 736.5 28.9999 735.8 28.9999C735.1 28.9999 734.5 28.3999 734.5 27.6999C734.5 26.9999 735.1 26.3999 735.8 26.3999C736.5 26.3999 737.1 26.9999 737.1 27.6999Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M744.001 47.2C743.901 47.2 743.801 47.0999 743.801 46.9999C743.801 46.8999 743.801 46.7999 743.901 46.7999C748.601 45.8999 751.701 42.9 751.701 42.9C751.801 42.8 751.901 42.8 752.001 42.9C752.101 43 752.101 43.1 752.001 43.2C752.101 43.2 748.901 46.3 744.001 47.2C744.101 47.2 744.101 47.2 744.001 47.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M749 24.4C748.9 24.4 748.8 24.4 748.7 24.3C748.7 24.3 747.5 23.7 744.6 23.9C744.3 23.9 744 23.7 744 23.4C744 23.1 744.2 22.8 744.5 22.8C747.7 22.5 749.1 23.3 749.2 23.3C749.5 23.4 749.6 23.8 749.4 24.1C749.4 24.3 749.2 24.4 749 24.4Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.4 38.9C735.4 38.9 736.2 41.6 738.6 42C741 42.4 742.8 39.7 742.8 39.7L740.1 38.1L735.4 38.9Z",
    fill: "#FBFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.201 24.7999C734.001 24.7999 733.901 24.6999 733.701 24.5999C733.501 24.3999 733.601 23.9999 733.801 23.7999C733.901 23.7999 735.301 22.6999 737.801 23.0999C738.101 23.0999 738.301 23.3999 738.301 23.6999C738.301 23.9999 738.001 24.1999 737.701 24.1999C735.701 23.8999 734.501 24.6999 734.501 24.6999C734.401 24.7999 734.301 24.7999 734.201 24.7999Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.6 39C747.9 38.6 747.6 39.8 747.1 40C746.8 40.2 746.7 40.1 746.5 40.1C746.1 40 745.5 39.5 745.1 38.9C744.8 38.5 744.7 38.1 744.4 37.7C743.2 36.2 741 36 739.7 36.5C738.5 35.6 737.3 35.9 735.9 36.4C735 36.7 734.6 37.5 733.9 38C733.2 38.6 732.5 39 731.9 39.1C731.5 39.1 731.4 38.5 731.2 38C731.2 37.8 731 37.7 730.9 37.7C730 37.5 730.1 39.1 730.3 39.8C730.5 40.5 731.4 41.1 732.1 41.1C734 41.2 735.4 40.3 736.7 39.2C736.9 39.1 737.6 38.9 737.8 38.9C738.6 38.9 740.1 39.1 740.8 39.2C741.1 39.3 742.4 39.8 742.5 39.9C743.8 41.6 746.7 43.2 748.2 41.1C748.5 40.6 748.7 40 748.7 39.5C748.8 39.3 748.7 39.1 748.6 39Z",
    fill: "#1E2E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.6 27.7C759.6 27.7 760 24.5 756.6 25.6C753.2 26.6 755.2 32.9 755.2 32.9L752.8 34.6C752.8 34.6 751.4 26.2 753.3 24.3C754.1 23.5 753.5 21.9 752.3 20.3C751.2 18.9 749.6 17.6 747.9 17.2C744.5 16.3 738.8 16.7 736.5 17.4C735.8 17.6 735.2 17.8 734.7 18.1C733.3 18.8 732.3 20.2 731.7 24.2C730.8 22.6 732.3 16.3 733.5 13.8C733.7 13.5 733.8 13.2 734 13.1C735.2 11.8 738.2 9.59996 743.5 9.69996C744.2 9.69996 744.2 10.1 744.8 10.2C745.1 10.1 745.7 9.79996 746 9.69996C749.1 8.99996 755.8 11 757.8 13.3C759.1 14.9 759.9 16.6 760.3 18.2C761.6 23.1 759.6 27.7 759.6 27.7Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.601 27.6999C759.601 27.6999 760.001 24.4999 756.601 25.5999C753.201 26.5999 755.201 32.8999 755.201 32.8999L752.801 34.5999C752.801 34.5999 751.401 26.1999 753.301 24.2999C754.101 23.4999 753.501 21.8999 752.301 20.2999L751.101 17.5999L754.601 18.9999V16.7999L756.601 18.2999V16.1999L758.501 17.8999L758.801 15.8999L760.201 18.0999C761.601 23.0999 759.601 27.6999 759.601 27.6999Z",
    fill: "#F8F9FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M755.7 34.7999C755.7 34.7999 758.5 34.8999 759.7 33.7999C761.5 32.0999 761.2 27.9999 759.9 25.9999C758.6 23.9999 756 25.1999 755.2 26.7999L755.7 34.7999Z",
    fill: "#FF7745"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M757.5 31.6C757.3 31.6 757.1 31.5 757 31.3C756.9 31 756.2 29.2 756.9 28.3C757.2 28 757.7 27.7 758.7 27.9C759 28 759.2 28.3 759.1 28.6C759 28.9 758.7 29.1 758.4 29C758.1 28.9 757.8 28.9 757.7 29C757.5 29.2 757.7 30.2 757.9 30.8C758 31.1 757.9 31.4 757.6 31.5C757.6 31.6 757.5 31.6 757.5 31.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M746.8 64.8C748.678 64.8 750.2 63.1882 750.2 61.2C750.2 59.2118 748.678 57.6 746.8 57.6C744.923 57.6 743.4 59.2118 743.4 61.2C743.4 63.1882 744.923 64.8 746.8 64.8Z",
    fill: "#DE3E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.8 59.4C744.8 59.4 738.4 55.7 736.7 56.5C735.1 57.3 736.5 59.7 736.7 60.4C736.9 61.1 736.1 62.4 736.4 64C736.7 65.6 738.4 65.6 740.9 65.1C743.4 64.6 745.7 62.6 745.7 62.6C745.7 62.6 747.6 59.9 744.8 59.4Z",
    fill: "#DD3D03"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M739.4 62.8999C739.3 62.8999 739.2 62.8999 739.1 62.8999C739 62.8999 738.9 62.7999 738.9 62.6999C738.9 62.5999 739 62.4999 739.1 62.4999C740.3 62.6999 743.1 61.2999 743.1 61.2999C743.2 61.2999 743.3 61.2999 743.3 61.3999C743.3 61.4999 743.3 61.5999 743.2 61.5999C743.2 61.6999 740.8 62.8999 739.4 62.8999Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.9 60.4C742.8 60.4 741.1 60.4 739.4 59.9C739.3 59.9 739.2 59.8 739.3 59.7C739.3 59.6 739.4 59.5 739.5 59.6C741.1 60 742.9 60 742.9 60C743 60 743.1 60.1 743.1 60.2C743.1 60.3 743 60.4 742.9 60.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M749.6 59.4C749.6 59.4 756 55.7 757.7 56.5C759.4 57.3 757.9 59.7 757.7 60.4C757.5 61.1 758.3 62.4 758 64C757.7 65.6 756 65.6 753.5 65.1C751 64.6 748.7 62.6 748.7 62.6C748.7 62.6 746.8 59.9 749.6 59.4Z",
    fill: "#DD3D03"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M751.4 60.7C751.3 60.7 751.2 60.6999 751.2 60.5999C751.2 60.4999 751.2 60.4 751.3 60.4C751.4 60.4 754.5 59.4 755.8 59.2C755.9 59.2 756 59.3 756 59.4C756 59.5 755.9 59.5999 755.8 59.5999C754.7 59.6999 751.5 60.7 751.4 60.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M755.3 62.5C753.9 62.1 751 62.3 751 62.3C750.9 62.3 750.8 62.2 750.8 62.1C750.8 62 750.9 61.9 751 61.9C751.1 61.9 754.1 61.7 755.4 62.1C755.5 62.1 755.6 62.2 755.5 62.3C755.4 62.5 755.4 62.5 755.3 62.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M769.7 55.3C765.6 52.7 755.9 52.2 755.8 52.2L755.9 51.1C756.3 51.1 766 51.6 770.3 54.4L769.7 55.3Z",
    fill: "#DC3C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.4 64H746.3V104.4H747.4V64Z",
    fill: "#DD3D03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.6 83.3C760.5 83.3 760.4 83.3 760.2 83.3C758.6 83.2 757.3 82.5 756.4 81.4C753.7 77.9 754.8 71.1 754.8 70.8L754.9 70.3H765.6L765.7 70.8C765.8 71.1 766.9 78.7 764 81.9C763.1 82.8 762 83.3 760.6 83.3ZM755.9 71.4C755.7 73 755.3 78.1 757.3 80.6C758 81.5 759 82 760.3 82.1C761.5 82.2 762.4 81.8 763.1 81C765.3 78.6 764.8 73 764.6 71.3H755.9V71.4Z",
    fill: "#DD3D03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.1 70.6H729.9V73.6H740.1V70.6Z",
    fill: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.3 56.2L723.8 55.2C731.1 51.6 738.2 51.5 738.5 51.5V52.6C738.5 52.7 731.4 52.8 724.3 56.2Z",
    fill: "#DC3C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.5 97.4C710 98.8 704.4 95.4 703 89.8L695.8 60.6C695 57.3 697 54 700.3 53.2L704.4 52.2C707.7 51.4 711 53.4 711.8 56.7L720 90C720.8 93.3 718.8 96.6 715.5 97.4Z",
    fill: "#1E2E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.6 66.2C696 68.7 692.7 55 702.3 52.8C711.9 50.3 715.3 64 705.6 66.2Z",
    fill: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703 71.1C698.3 71.1 696.7 67 696.6 67L697.9 66.5C698 66.7 699.5 70.4 704.2 69.6L704.4 71C704 71.1 703.5 71.1 703 71.1Z",
    fill: "#DD3D03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.6 75.6C698.9 75.6 697.3 71.5 697.2 71.5L698.5 71C698.6 71.2 700.1 74.9 704.8 74.1L705 75.5C704.6 75.6 704.1 75.6 703.6 75.6Z",
    fill: "#DD3D03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.5 60.8C709.1 54.9 706 55 703.5 53.1C701.6 51.6 700.6 51.3 700.2 50.9C698.1 48.9 695 46.6 693.6 46.8C691.7 47.2 695.9 50.5 695.9 50.5C695.9 50.5 691.7 46.1 690.5 47.3C689.8 48 690.3 49.5 691.9 51C690.1 49.4 689.5 45.9 688.6 46.8C687.6 47.8 690 52.8 690.5 53.3C690 52.9 687.6 49 686.3 50C684.9 51.1 692.5 58.3 692.5 58.3C692.5 58.3 699.2 63.5 700.9 63.6C705.4 63.7 709.7 63.3 709.5 60.8Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.1 57.1L685 50.7L683.2 14.5L694 21L696.1 57.1Z",
    fill: "#F8BA5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.1 57.1L713.7 59.6L711.9 23.5L694 21L696.1 57.1Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.9 58.1C696.9 58.1 694.1 53.1 695.9 52.1C697.8 51.1 699.7 55.2 699.7 55.2C699.7 55.2 706.5 59.2 707.1 61.2C707.7 63.2 699.4 62 699.4 62L696.9 58.1Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.5 29.3999L697.8 27.7999C697.5 27.7999 697.3 27.4999 697.4 27.1999C697.4 26.8999 697.7 26.6999 698 26.7999L708.6 28.3999C708.9 28.3999 709.1 28.6999 709 28.9999C709 29.1999 708.8 29.3999 708.5 29.3999Z",
    fill: "#F9BB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.5 35.7L698.2 34.1C697.9 34.1 697.7 33.8 697.8 33.5C697.8 33.2 698.1 33 698.4 33.1L708.7 34.7C709 34.7 709.2 35 709.1 35.3C709 35.6 708.8 35.7 708.5 35.7Z",
    fill: "#F9BB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709 42.3999L698.7 40.7999C698.4 40.7999 698.2 40.4999 698.3 40.1999C698.3 39.8999 698.6 39.6999 698.9 39.7999L709.2 41.3999C709.5 41.3999 709.7 41.6999 709.6 41.9999C709.4 42.1999 709.2 42.3999 709 42.3999Z",
    fill: "#F9BB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.5 49.3999L699.2 47.7999C698.9 47.7999 698.7 47.4999 698.8 47.1999C698.8 46.8999 699.1 46.6999 699.4 46.7999L709.7 48.3999C710 48.3999 710.2 48.6999 710.1 48.9999C710 49.1999 709.7 49.3999 709.5 49.3999Z",
    fill: "#F9BB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.601 26.3999C692.501 26.3999 692.401 26.3999 692.401 26.2999L685.601 22.7999C685.401 22.6999 685.301 22.3999 685.401 22.0999C685.501 21.8999 685.801 21.7999 686.101 21.8999L692.901 25.3999C693.101 25.4999 693.201 25.7999 693.101 26.0999C693.001 26.2999 692.801 26.3999 692.601 26.3999Z",
    fill: "#FEE51B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.6 32.9C692.5 32.9 692.5 32.9 692.4 32.9L685.9 30C685.6 29.9 685.5 29.6 685.7 29.3C685.8 29 686.1 28.9 686.4 29.1L692.9 32C693.2 32.1 693.3 32.4 693.1 32.7C693 32.8 692.8 32.9 692.6 32.9Z",
    fill: "#FEE51B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.4 39.8C692.3 39.8 692.3 39.8 692.2 39.8L686.2 36.9C686 36.8 685.8 36.5 686 36.2C686.1 35.9 686.4 35.8 686.7 36L692.7 38.9C692.9 39 693.1 39.3 692.9 39.6C692.8 39.7 692.6 39.8 692.4 39.8Z",
    fill: "#FEE51B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.6 46.7C692.5 46.7 692.5 46.7 692.4 46.7L686.4 43.7999C686.2 43.6999 686 43.3999 686.2 43.0999C686.3 42.7999 686.6 42.7 686.9 42.9L692.9 45.7999C693.1 45.8999 693.3 46.1999 693.1 46.4999C693 46.4999 692.8 46.7 692.6 46.7Z",
    fill: "#FEE51B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.4 81.8C787.1 81.7 791.6 76.9 791.5 71.2L790.8 41.2C790.7 37.8 787.9 35.1 784.5 35.2L780.3 35.3C776.9 35.4 774.2 38.2 774.3 41.6L775.1 75.9C775.2 79.2 778 81.9 781.4 81.8Z",
    fill: "#1E2E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.6 45.0999C792.5 44.9999 792.3 35.4999 782.4 35.7999C772.5 35.9999 772.7 45.3999 782.6 45.0999Z",
    fill: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.1 53.3999L785 51.9999C789.8 51.4999 790.2 47.4999 790.3 47.2999L791.7 47.3999C791.6 47.4999 791 52.6999 785.1 53.3999Z",
    fill: "#DD3D03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.7 57.8999L785.6 56.4999C790.3 55.9999 790.8 51.9999 790.9 51.7999L792.3 51.8999C792.2 51.9999 791.6 57.2999 785.7 57.8999Z",
    fill: "#DD3D03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.1 42.9C784.7 43.5 787.9 42.4 788.3 38.6C788.5 36.7 789.7 34.9 790 33.5C790.7 30.7 790.3 26.6 789.1 26.3C787.5 25.9 787.9 28.1 787.9 28.1C787.9 28.1 788.3 24.7 786.2 24.5C784.9 24.4 784.7 25.6 784.9 27.5C784.6 24.5 784.3 24 783.4 23.8C782 23.6 781.4 24.3 781.3 25.7C780.5 25.1 781.4 14.7 779.2 14.6C776.8 14.5 777.6 24.9 777.6 24.9C777.6 24.9 778.3 30.3 777.2 30C776.2 29.8 774 26.2 773.2 26.6C771.3 27.7 775.2 33.4 776.2 35.3C778.6 40.3 776.1 42.4 780.1 42.9Z",
    fill: "#FF7845"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20994_306977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWidgetSuggestion);
export default __webpack_public_path__ + "static/media/BackgroundWidgetSuggestion.9249e02a.svg";
export { ForwardRef as ReactComponent };